import { BreakpointObserver } from "@angular/cdk/layout";
import { Directive, ElementRef, Input, OnChanges, OnDestroy, OnInit, Renderer2, SimpleChanges } from "@angular/core";
import { Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";
import { FX_MEDIA_QUERIES, FxBreakpoint, pickResponsiveValue, toBoolean } from "./breakpoints";

@Directive()
abstract class FxVisibilityBase implements OnInit, OnChanges, OnDestroy {
  protected base?: unknown;
  protected overrides: Partial<Record<FxBreakpoint, unknown>> = {};
  private readonly destroy$ = new Subject<void>();
  private readonly active = new Set<FxBreakpoint>();
  protected constructor(protected readonly host: ElementRef<HTMLElement>, protected readonly renderer: Renderer2, private readonly observer: BreakpointObserver) {}
  ngOnInit(): void {
    this.observer.observe(Object.values(FX_MEDIA_QUERIES)).pipe(takeUntil(this.destroy$)).subscribe(state => {
      this.active.clear();
      (Object.keys(FX_MEDIA_QUERIES) as FxBreakpoint[]).forEach(bp => { if (state.breakpoints[FX_MEDIA_QUERIES[bp]]) this.active.add(bp); });
      this.apply();
    });
    this.apply();
  }
  ngOnChanges(_: SimpleChanges): void { this.syncInputs(); this.apply(); }
  ngOnDestroy(): void { this.destroy$.next(); this.destroy$.complete(); }
  protected abstract syncInputs(): void;
  protected abstract isHidden(value: unknown): boolean;
  private apply(): void {
    const value = pickResponsiveValue(this.base, this.overrides, bp => this.active.has(bp));
    if (this.isHidden(value)) this.renderer.setStyle(this.host.nativeElement, "display", "none");
    else this.renderer.removeStyle(this.host.nativeElement, "display");
  }
}

@Directive({ standalone: false, selector: "[fxShow]" })
export class FxShowDirective extends FxVisibilityBase {
  @Input() fxShow?: unknown; @Input("fxShow.xs") xs?: unknown; @Input("fxShow.sm") sm?: unknown; @Input("fxShow.md") md?: unknown; @Input("fxShow.gt-xs") gtXs?: unknown; @Input("fxShow.gt-sm") gtSm?: unknown; @Input("fxShow.gt-md") gtMd?: unknown;
  constructor(host: ElementRef<HTMLElement>, renderer: Renderer2, observer: BreakpointObserver) { super(host, renderer, observer); }
  protected syncInputs(): void { this.base = this.fxShow; this.overrides = { xs: this.xs, sm: this.sm, md: this.md, "gt-xs": this.gtXs, "gt-sm": this.gtSm, "gt-md": this.gtMd }; }
  protected isHidden(value: unknown): boolean { return !toBoolean(value, true); }
}

@Directive({ standalone: false, selector: "[fxHide]" })
export class FxHideDirective extends FxVisibilityBase {
  @Input() fxHide?: unknown; @Input("fxHide.xs") xs?: unknown; @Input("fxHide.sm") sm?: unknown; @Input("fxHide.md") md?: unknown; @Input("fxHide.gt-xs") gtXs?: unknown; @Input("fxHide.gt-sm") gtSm?: unknown; @Input("fxHide.gt-md") gtMd?: unknown;
  constructor(host: ElementRef<HTMLElement>, renderer: Renderer2, observer: BreakpointObserver) { super(host, renderer, observer); }
  protected syncInputs(): void { this.base = this.fxHide; this.overrides = { xs: this.xs, sm: this.sm, md: this.md, "gt-xs": this.gtXs, "gt-sm": this.gtSm, "gt-md": this.gtMd }; }
  protected isHidden(value: unknown): boolean { return toBoolean(value, true); }
}
